"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSummaryStore = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const timsort_1 = require("timsort");
const services_1 = require("../services");
function sortSummaries(summaryA, summaryB) {
    return summaryB.createdAt.localeCompare(summaryA.createdAt);
}
class FormSummaryStore {
    refresh() {
        if (services_1.Services.Department.rest != null) {
            // Don't list stale form summaries for slow connections
            services_1.Services.Department.rest.formSummaries.init([]);
            services_1.Services.Department.rest.formSummaries.refetch();
        }
    }
    get(revision) {
        const rest = services_1.Services.Department.rest;
        return rest.Form.Summary.getByRevision(revision).value;
    }
    getAsync(revision) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = services_1.Services.Department.rest;
            return yield rest.Form.Summary.getByRevision(revision).fetch();
        });
    }
    /**
     * List of un-deleted latest form summaries deduped by form uuid
     */
    get all() {
        if (services_1.Services.Department.current == null) {
            return [];
        }
        const rest = services_1.Services.Department.rest;
        const summaries = rest.formSummaries.value;
        if (summaries == null) {
            return [];
        }
        // Already sorted from server but good to be careful
        (0, timsort_1.sort)(summaries, sortSummaries);
        return summaries;
    }
}
exports.FormSummaryStore = FormSummaryStore;
tslib_1.__decorate([
    mobx_1.computed
], FormSummaryStore.prototype, "all", null);
//# sourceMappingURL=form.summary.store.js.map